import axios from "axios";
import authHeader from "services/auth-header";

class MealService {
  listMeals(params) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + `meals/food_log`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        return response.data;
      });
  }

  updateMeal(id, params) {
    return axios
      .put(process.env.REACT_APP_API_ENDPOINT + `meals/${id}`, params, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  getComments(id) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + `meals/${id}/meal_comments`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  createComment(id, params) {
    return axios
      .post(
        process.env.REACT_APP_API_ENDPOINT + `meals/${id}/meal_comments`,
        params,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  deleteComment(id, comment_id) {
    return axios
      .delete(
        process.env.REACT_APP_API_ENDPOINT +
          `meals/${id}/meal_comments/${comment_id}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  updateRead(id) {
    return axios
      .put(
        process.env.REACT_APP_API_ENDPOINT +
          `meals/${id}/meal_comments/update_read`,
        {},
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  getOpenChat(params) {
    return axios
      .get(
        process.env.REACT_APP_API_ENDPOINT +
          `chat_sessions/has_health_coach_session`,
        {
          headers: authHeader(),
          params: params,
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  createChat(params) {
    return axios
      .post(process.env.REACT_APP_API_ENDPOINT + `chat_sessions`, params, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
}

export default new MealService();
